export const RESET_STATE = (state) => {};

export const UP_TIME_DURATION = (state, val) => {
  state.selectedTimeDuration = val;
};

export const UP_TOTAL_CHARACTERS = (state, val) => {
  state.totalCharacters = val;
};

const randomString = (
  chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz",
  string_length = 8
) => {
  var randomstring = "";
  for (var i = 0; i < string_length; i++) {
    var rnum = Math.floor(Math.random() * chars.length);
    randomstring += chars.substring(rnum, rnum + 1);
  }
  return randomstring;
};

export const SET_TYPING_CONTENT = (state, { lesson, strChar }) => {
  strChar = strChar + " " + strChar;
  let content = randomString(strChar, state.totalCharacters);

  state.lessons[lesson].content = content;
};

export const UP_TYPING_WORDS_LENGTH = (state, val) => {
  state.selectedTypingWordsLength = val;
};

export const UP_DISABLE_BACKSPACE = (state, val) => {
  state.isDisableBackSpace = val;
};
